<ng-container *ngIf="!isLoading">
    <div class="title p-2">
        <div class="row">
            <div class="col d-flex justify-content-start align-items-center">
                <h1 class="mx-1">
                    <span>Info Proiect</span>
                    <span class="text-secondary ms-2">#{{ proiect?.id_proiect }}</span>
                    <span *ngIf="proiect?.source === 1" class="mx-2">- <b class="green-text">WEB</b></span>
                    <button type="button" class="btn btn-small btn-primary" (click)="getProiectInfo(true)">
                        <i class="fa-solid fa-arrows-rotate me-1"></i>
                        <span>Reîncarcă informații</span>
                    </button>
                </h1>
            </div>
            <div class="col d-flex justify-content-end">
                <button type="button" class="action-btn" (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="row p-3 responsive-content">
        <div class="col-8">
            <app-continut-proiect *ngIf="proiect" [proiect]="proiect!" [motive]="motiveActive!"
                (proiectChanged)="getProiectInfo()"></app-continut-proiect>

            <app-info-inchidere-proiect *ngIf="proiect && (proiect?.finished_type || proiect?.finished_date)"
                [proiect]="proiect!" (proiectChanged)="getProiectInfo()"></app-info-inchidere-proiect>

            <app-locatie-proiect *ngIf="proiect" [proiect]="proiect!"
                (proiectChanged)="getProiectInfo()"></app-locatie-proiect>

            <app-responsabili-proiect *ngIf="proiect" [proiect]="proiect!" [directiiActive]="directiiActive!"
                (proiectChanged)="getProiectInfo()"></app-responsabili-proiect>

            <app-operatori-proiect *ngIf="proiect" [proiect]="proiect!" [operatoriTeren]="operatoriTeren!"
                (proiectChanged)="getProiectInfo()"></app-operatori-proiect>

            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-documents">
                        <div class="box-content-header">
                            <div class="row p-1">
                                <div class="col">
                                    <div class="px-2 d-flex justify-content-between align-items-center">
                                        <div>
                                            <i class="fa fa-history"></i>
                                            <span class="ms-2">Istoric acțiuni operatori</span>
                                        </div>
                                        <button class="btn btn-small btn-primary toggle-btn" (click)="toggleIstoric()">
                                            <i class="fa fa-plus" *ngIf="!showIstoric"></i>
                                            <i class="fa fa-close" *ngIf="showIstoric"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <table class="table" *ngIf="showIstoric">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Operator</th>
                                        <th scope="col">Motiv</th>
                                        <th scope="col">Dată</th>
                                        <th scope="col">Început</th>
                                        <th scope="col">Finalizare</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let istoric_item of proiect?.istoric; let i = index">
                                        <th scope="row">{{ i + 1 }}</th>
                                        <td>{{ istoric_item.user_name }}</td>
                                        <td>{{ istoric_item.motiv_obs }}</td>
                                        <td>{{ istoric_item.created_at | date: "dd-MM-yyyy HH:mm:ss" }}</td>
                                        <td>
                                            <div>
                                                <span class="fw-bold">Vechi:</span> {{ istoric_item.data_inceput_init |
                                                date:"dd-MM-yyyy" }}
                                            </div>
                                            <div>
                                                <span class="fw-bold">Nou:</span> {{ istoric_item.data_inceput_reala |
                                                date: "dd-MM-yyyy" }}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <span class="fw-bold">Vechi:</span> {{ istoric_item.data_finalizare_init
                                                | date: "dd-MM-yyyy" }}
                                            </div>
                                            <div>
                                                <span class="fw-bold">Nou:</span> {{ istoric_item.data_finalizare_reala
                                                | date:"dd-MM-yyyy" }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-documents">
                        <div class="box-content-header">
                            <div class="row p-1">
                                <div class="col">
                                    <div class="px-2 d-flex justify-content-between align-items-center">
                                        <div>
                                            <i class="fa-solid fa-folder-tree"></i>
                                            <span class="ms-2">Documente</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <div *ngFor="let file of proiect?.documente">
                                <div class="row align-items-center m-2">
                                    <div class="col-auto">
                                        <img src="assets/icons/doc-icon.svg" alt="Document">
                                    </div>
                                    <div class="col">
                                        <div class="document-title">{{ file.type_name }}</div>
                                        <div>Denumire document: {{ file.name_original }}</div>
                                    </div>
                                    <div class="col-auto ms-auto">
                                        <button type="button" class="btn btn-light document-open-btn"
                                            (click)="downloadDocument(file.id_document)">
                                            <img src="/assets/icons/view.svg" alt="VIZUALIZAȚI" />
                                            <span class="text">VIZUALIZAȚI</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-mesagerie *ngIf="proiect" [proiect]="proiect!" (proiectChanged)="getProiectInfo()"></app-mesagerie>

            <app-istoric-proiect *ngIf="istoric" [istoric]="istoric!" [user]="user!"
                (proiectChanged)="getProiectInfo()" (isLoading)="onIsLoadingChange($event)"></app-istoric-proiect>
        </div>

        <div class="col-4">
            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-documents">
                        <div class="box-content-header">
                            <div class="row p-1">
                                <div class="col">
                                    <div class="px-2 d-flex justify-content-between align-items-center">
                                        <div>
                                            <i class="fa-solid fa-circle-info"></i>
                                            <span class="ms-2">Info Proiect</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <table class="table table-condensed table-wrapper-box">
                                <tbody>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Denumire</strong>
                                        </td>
                                        <td *ngIf="!editProiectName" class="text-left">
                                            {{ proiect?.subject }}
                                            <button
                                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                                class="btn btn-small btn-primary" (click)="toggleEditProiectName()">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                        </td>
                                        <td *ngIf="editProiectName" class="text-left">
                                            <div class="row">
                                                <div class="col">
                                                    <mat-form-field class="w-100" appearance="fill">
                                                        <mat-label>Actualizare nume proiect</mat-label>
                                                        <input matInput [(ngModel)]="proiectName" name="proiectName" />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col d-flex justify-content-start">
                                                    <button class="btn btn-small btn-warning"
                                                        (click)="closeEditProiectName()">
                                                        Închide
                                                    </button>
                                                </div>
                                                <div class="col d-flex justify-content-end">
                                                    <button class="btn btn-small btn-primary"
                                                        (click)="updateProiectName()">
                                                        Salvează
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Furnizor</strong>
                                        </td>
                                        <td class="text-left">
                                            {{ proiect?.provider?.name }}
                                            <button
                                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                                class="btn btn-small btn-primary" (click)="openUpdateFurnizorDialog()">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Status</strong>
                                        </td>
                                        <td class="text-left">
                                            <span class="badge" [ngStyle]="{
                                                'background-color': proiect?.status?.color,
                                                'color': proiect?.status?.bgColor
                                            }">
                                                {{ proiect?.status?.name }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Tag</strong>
                                        </td>
                                        <td *ngIf="!editTagName" class="text-left">
                                            {{ proiect?.tag?.name }}
                                            <button
                                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                                class="btn btn-small btn-primary" (click)="toggleEditTagName()">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                        </td>
                                        <td *ngIf="editTagName" class="text-left">
                                            <form [formGroup]="searchTagForm" (ngSubmit)="updateTagName()">
                                                <div class="row">
                                                    <div class="col">
                                                        <mat-form-field class="w-100" appearance="fill">
                                                            <mat-label>Actualizare tag proiect</mat-label>
                                                            <input type="text" matInput formControlName="name_tag"
                                                                [matAutocomplete]="auto" />
                                                            <mat-icon *ngIf="!searchTagLoading" matSuffix
                                                                class="opacity-50">search</mat-icon>
                                                            <mat-spinner *ngIf="searchTagLoading" matSuffix
                                                                [diameter]="48"></mat-spinner>
                                                            <mat-autocomplete #auto="matAutocomplete">
                                                                <mat-option *ngFor="let tag of searchedTags"
                                                                    [value]="tag.name"
                                                                    (onSelectionChange)="onTagSelected(tag)">
                                                                    {{ tag.name }}
                                                                </mat-option>
                                                            </mat-autocomplete>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col d-flex justify-content-start">
                                                        <button type="button" class="btn btn-small btn-warning"
                                                            (click)="closeEditTagName()">
                                                            Închide
                                                        </button>
                                                    </div>
                                                    <div class="col d-flex justify-content-end">
                                                        <button type="submit" class="btn btn-small btn-primary"
                                                            [disabled]="searchTagForm.invalid">
                                                            Salvează
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Compartiment</strong>
                                        </td>
                                        <td class="text-left">
                                            {{ proiect?.compartiment_name }}
                                            <button
                                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                                class="btn btn-small btn-primary"
                                                (click)="openUpdateCompartimentDialog()">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Direcție</strong>
                                        </td>
                                        <td class="text-left">
                                            {{ proiect?.directie_name }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Proiect asignat</strong>
                                        </td>
                                        <td class="text-left">{{ proiect?.user_assigned || 'n/a' }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Categorie</strong>
                                        </td>
                                        <td class="text-left">
                                            {{ proiect?.categorie }}
                                            <button
                                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                                class="btn btn-small btn-primary" (click)="openUpdateCategorieDialog()">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Secțiune</strong>
                                        </td>
                                        <td class="text-left">{{ proiect?.sectiune }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Dată creat</strong>
                                        </td>
                                        <td class="text-left">{{ proiect?.created_at | date: 'dd-MM-yyyy HH:mm:ss' }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Dată actualizat</strong>
                                        </td>
                                        <td class="text-left">{{ proiect?.updated_at | date: 'dd-MM-yyyy HH:mm:ss' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-documents">
                        <div class="box-content-header">
                            <div class="row p-1">
                                <div class="col">
                                    <div class="px-2 d-flex justify-content-between align-items-center">
                                        <div>
                                            <i class="fa-solid fa-shuffle"></i>
                                            <span class="ms-2">Acțiuni Proiect</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <div class="row p-2 d-flex">
                                <div class="col">
                                    <app-actiuni-proiect-card title="Status Închis" description="Neînchis"
                                        iconName="check" [proiect]="proiect!" actionText="Închide"
                                        actionType="inchidere"
                                        (buttonClicked)="handleButtonClick($event)"></app-actiuni-proiect-card>
                                </div>
                                <div class="col">
                                    <app-actiuni-proiect-card title="Status Anulat" description="Neanulat"
                                        iconName="report_problem" [proiect]="proiect!" actionText="Anulează"
                                        actionType="anulare"
                                        (buttonClicked)="handleButtonClick($event)"></app-actiuni-proiect-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-actualizare-proiect *ngIf="proiect" [proiect]="proiect!"
                (proiectChanged)="getProiectInfo()"></app-actualizare-proiect>
        </div>
    </div>
</ng-container>
<div class="section-spinner position-fixed" *ngIf="isLoading || isLoadingOtherInfos">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/icons/logo-ps4-icon.svg" height="50%" width="50%" alt="PS4" />
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>